import { a as rem, i as _responsive, n as _getArrayProp } from "./helpers-bwfx1e-Y.js";
import { t as getTheme_v2 } from "./getTheme_v2-y09KqtEb.js";
import { x as flexItemStyle, y as Box } from "./useLayer-BAVfmbNN.js";
import { c } from "react/compiler-runtime";
import { styled } from "styled-components";
import { jsx } from "react/jsx-runtime";
const BASE_STYLE = { "&&:not([hidden])": { display: "flex" } };
function responsiveFlexStyle() {
	return [
		BASE_STYLE,
		responsiveFlexAlignStyle,
		responsiveFlexGapStyle,
		responsiveFlexWrapStyle,
		responsiveFlexJustifyStyle,
		responsiveFlexDirectionStyle
	];
}
function responsiveFlexAlignStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$align, (align) => ({ alignItems: align }));
}
function responsiveFlexGapStyle(props) {
	let { media, space } = getTheme_v2(props.theme);
	return _responsive(media, props.$gap, (gap) => ({ gap: gap ? rem(space[gap]) : void 0 }));
}
function responsiveFlexWrapStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$wrap, (wrap) => ({ flexWrap: wrap }));
}
function responsiveFlexJustifyStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$justify, (justify) => ({ justifyContent: justify }));
}
function responsiveFlexDirectionStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$direction, (direction) => ({ flexDirection: direction }));
}
const StyledFlex = /* @__PURE__ */ styled(Box).withConfig({
	displayName: "StyledFlex",
	componentId: "sc-amdlvw-0"
})(flexItemStyle, responsiveFlexStyle);
function FlexComponent(props) {
	let $ = c(28), align, as, gap, justify, ref, restProps, t0, wrap;
	$[0] === props ? (align = $[1], as = $[2], gap = $[3], justify = $[4], ref = $[5], restProps = $[6], t0 = $[7], wrap = $[8]) : ({align, as, direction: t0, gap, justify, ref, wrap, ...restProps} = props, $[0] = props, $[1] = align, $[2] = as, $[3] = gap, $[4] = justify, $[5] = ref, $[6] = restProps, $[7] = t0, $[8] = wrap);
	let direction = t0 === void 0 ? "row" : t0, t1;
	$[9] === align ? t1 = $[10] : (t1 = _getArrayProp(align), $[9] = align, $[10] = t1);
	let t2;
	$[11] === direction ? t2 = $[12] : (t2 = _getArrayProp(direction), $[11] = direction, $[12] = t2);
	let t3;
	$[13] === gap ? t3 = $[14] : (t3 = _getArrayProp(gap), $[13] = gap, $[14] = t3);
	let t4;
	$[15] === justify ? t4 = $[16] : (t4 = _getArrayProp(justify), $[15] = justify, $[16] = t4);
	let t5;
	$[17] === wrap ? t5 = $[18] : (t5 = _getArrayProp(wrap), $[17] = wrap, $[18] = t5);
	let t6;
	return $[19] !== as || $[20] !== ref || $[21] !== restProps || $[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 ? (t6 = /* @__PURE__ */ jsx(StyledFlex, {
		"data-ui": "Flex",
		...restProps,
		$align: t1,
		$direction: t2,
		$gap: t3,
		$justify: t4,
		$wrap: t5,
		forwardedAs: as,
		ref
	}), $[19] = as, $[20] = ref, $[21] = restProps, $[22] = t1, $[23] = t2, $[24] = t3, $[25] = t4, $[26] = t5, $[27] = t6) : t6 = $[27], t6;
}
/**
* The `Flex` component is a wrapper component for flexible elements (`Box`, `Card` and `Flex`).
*
* @public
*/
const Flex = FlexComponent;
export { Flex as t };

//# sourceMappingURL=flex-C-5JHi1C.js.map